import { Component, Element, h, Host, JSX, Prop, State } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { componentsOnReady } from "@phn/utility/ready";
import { Timeout } from "@phn/utility/timeout";
import { Series } from "../../../../shared/entities/content";
import { getModelsRoutingKey } from "../../../../shared/entities/routing-key";
import { navStateStore } from "../../../../shared/state/nav-state-store";
import {
  EventActions,
  MenuItemVariant,
} from "../../../../shared/utility/constants";
import { addRoute } from "../../../../shared/services/routing-manager";
import { getSeriesImage } from "../../../../shared/utility/navi-state";

@Component({
  tag: "phn-nd-models",
  styleUrl: "models.scss",
  assetsDirs: ["series-assets"],
  scoped: true,
})
export class Models {
  @Prop() breakpoint!: number;

  @Prop() showHeadline = false;

  @State() showSkeleton = false;

  @Element() el!: HTMLPhnNdModelsElement;

  private async waitForComponentsToLoad() {
    await componentsOnReady(this.el, new Timeout(5000));
  }

  componentWillLoad(): void {
    this.waitForComponentsToLoad();
  }

  private showMenuWithModels(series: Series): void {
    addRoute([series.id]);
  }

  private getImageSource(image: string): string {
    return getSeriesImage(image, navStateStore.state.env);
  }

  render(): JSX.Element {
    const { models } = navContentStore.state;

    return (
      <Host>
        <ul>
          {models.series.map((modelsSeries) => (
            <phn-nd-menu-item
              key={modelsSeries.id}
              class={`series ${this.showSkeleton ? "skeleton" : ""}`}
              elementId={getModelsRoutingKey(modelsSeries.id)}
              analyticsId={modelsSeries.id}
              text={modelsSeries.name}
              subtext={modelsSeries.tags.map((tag) => tag.text).join(" | ")}
              onClick={() => this.showMenuWithModels(modelsSeries)}
              variant={MenuItemVariant.Model}
              isModels={true}
              datalayerEventAction={EventActions.MODEL_RANGE_CLICK}
              role="listitem"
            >
              <phn-model-tile
                slot="model-area"
                level="l2"
                breakpoint={this.breakpoint}
                modelSeries={modelsSeries}
                srcSet={this.getImageSource(modelsSeries.image)}
                datalayerEventAction={EventActions.MODEL_RANGE_CLICK}
              ></phn-model-tile>
            </phn-nd-menu-item>
          ))}
        </ul>
        <phn-nd-more-content-indicator level="l2"></phn-nd-more-content-indicator>
      </Host>
    );
  }
}
